<template>
  <div id="app">
    <div class="loading" v-if="loading">Loading...</div>
    <template v-else>
      <div class="title">
        <template v-for="text in data.common.title">
          <div :key="text.id">{{ $route.query.lang === "en" ? text.en : text.hu }}</div>
        </template>
      </div>

      <div class="subtitle">
        <template v-for="text in data.common.subtitle">
          <div :key="text.id">{{ $route.query.lang === "en" ? text.en : text.hu }}</div>
        </template>
      </div>

      <router-view :dataObj="data"></router-view>

      <transition name="fade">
        <nav v-if="menuIsActive" ref="nav">
          <div class="links">
            <template v-for="link in data.common.links">
              <router-link
                :key="link.id"
                :to="{ path: link.url, query: { lang: $route.query.lang } }"
              >
                {{
                $route.query.lang === "en" ? link.en : link.hu
                }}
              </router-link>
            </template>
          </div>
        </nav>
      </transition>

      <div class="menu">
        <div class="menu__lang" @click="changeLang" v-html="symbol"></div>
        <div class="menu__toggle" @click="menuIsActive = !menuIsActive">&#57352;</div>
      </div>
    </template>
  </div>
</template>

<style scoped>
#app {
  padding: 20px;
}

.menu {
  display: flex;
  position: fixed;
  top: 40px;
  right: 40px;
  z-index: 3;
  user-select: none;
}

.menu__lang {
  margin-right: 10px;
}

.menu__lang,
.menu__toggle {
  cursor: pointer;
}

nav {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: fixed;
  top: 0;
  right: 0;
  width: 50%;
  height: 100vh;
  line-height: 1em;
  text-transform: uppercase;
  background-color: rgba(225, 225, 225, 0.8);
  backdrop-filter: blur(5px);
  z-index: 2;
  transition: opacity 500ms;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s linear;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.links {
  display: flex;
  flex-direction: column;
  font-size: 10px;
}

.links > a {
  border-bottom: 1px solid #000000;
  padding: 20px;
  text-align: right;
  transition: background-color 0.25s ease-in-out;
}

.links .active:before {
  content: "•";
  margin-right: 10px;
}

.links > a:last-child {
  border-bottom: 0;
}

.links > a:hover {
  background-color: rgba(211, 211, 211, 0.5);
}

.title,
.subtitle {
  display: inline-block;
  position: relative;
  margin: 20px;
  width: calc(100% - 40px);
  text-transform: uppercase;
}

.title div {
  float: left;
  clear: both;
  border-bottom: 1px solid #000000;
}

.subtitle div {
  float: left;
  clear: both;
}

@media screen and (max-width: 960px) {
  nav {
    width: 100%;
  }
}

@media screen and (max-width: 600px) {
  #app {
    padding: 0;
  }

  .menu {
    top: 20px;
    right: 20px;
  }
}
</style>

<script>
export default {
  title: "App",
  data() {
    return {
      menuIsActive: false,
      symbol: "",
      loading: false,
      data: {}
    };
  },
  methods: {
    changeLang() {
      this.$router
        .push({
          query: {
            lang: this.$route.query.lang === "en" ? "hu" : "en"
          }
        })
        .catch();
      this.symbol = this.$route.query.lang === "en" ? "&#57345;" : "&#57344;";
    },
    fetchData() {
      this.loading = true;

      fetch("/api/data.json")
        .then(res => res.json())
        .then(result => {
          this.data = result;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  created() {
    console.log(
      "%c* Design & Development: Dániel Kophelyi *",
      "padding: 5px 10px; background-color: #000000; color: #ffffff;"
    );
    this.fetchData();
    if (
      !this.$route.query.lang ||
      (this.$route.query.lang !== "en" && this.$route.query.lang !== "hu")
    ) {
      this.$router
        .push({
          query: {
            lang: "en"
          }
        })
        .catch();
    }
    this.symbol = this.$route.query.lang === "en" ? "&#57345;" : "&#57344;";
  },
  watch: {
    "$route.path": function(to, from) {
      if (to != from) {
        this.menuIsActive = false;
      }
    }
  }
};
</script>
